import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LGbanner from "../Page-section/lead-generation/LGbanner";
import LGprocess from "../Page-section/lead-generation/LGprocess";
import { useSEO } from "../hooks/useSEO";

function LeadGeneration() {
  useSEO({
    title: "Lead Generation Services to Boost Sales & High-Quality Leads",
    description:
      "Get expert Lead Generation Services to attract high-quality leads, boost conversions, and grow your business faster with proven strategies. Start today!",
    canonical: "https://empowerweb.in/lead-generation-services",
    ogTitle: "lead generation services,  b2b lead generation services",
    ogDescription:
      "Generate qualified leads with data-driven strategies. B2B, B2C, and vertical-specific lead generation.",
    keywords:
      "lead generation services,  b2b lead generation services,  lead generation company in india, lead generation companies in noida,lead generation services ",
  });
  return (
    <div>
      <Header />
      <Navbar />
      <main>
        <LGbanner />
        <LGprocess />
      </main>
      <Footer />
    
    </div>
  );
}

export default LeadGeneration;
